import * as React from 'react';
import cx from 'classnames';
import {LabeledButton} from './LabeledButton';
import ImgButton from './ImgButton';
import {ILabeledButtonProps} from './LabeledButton';

export interface IButtonProps extends Partial<ILabeledButtonProps> {
    labeled?: boolean;
    roundCorners?: boolean;
    onMouseDown?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const Button: React.FC<IButtonProps> = props => {
    const {onClick, onMouseDown, componentClasses, text, labeled, img, alt} = props;

    if (labeled) {
        return <LabeledButton {...props} />;
    } else if (img) {
        return (
            <ImgButton
                componentClasses={componentClasses}
                onClick={onClick}
                onMouseDown={onMouseDown}
                img={img}
                alt={alt}
            />
        );
    } else {
        return (
            <div className={cx(`button`, componentClasses)} onClick={onClick}>
                {text}
            </div>
        );
    }
};
